import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'aws-amplify';

import { withStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import logo from './logo.png';

const styles = {
  root: {
    backgroundColor:"#f6f6f6",
  },
};

class SimpleBottomNavigation extends React.Component {
  state = {
    value: 0,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { classes } = this.props;
    const { value } = this.state;

    return (
      <div className="mypageFooter">
        <img alt="lapsys logo" src={logo} />
        <BottomNavigation
          value={value}
          onChange={this.handleChange}
          showLabels
          className={classes.root}
        >
          <a className="mypageFooterLink" target="_blank" rel="noopener noreferrer" href={I18n.get('https://www.lapsys.co.jp/english/')}>
            {I18n.get('Company information')}
          </a>
          <a className="mypageFooterLink" target="_blank" rel="noopener noreferrer" href={I18n.get('https://www.lapsys.co.jp/english/policy/laplace_id.html')}>
            {I18n.get('Terms of service')}
          </a>
          <a className="mypageFooterLink" target="_blank" rel="noopener noreferrer" href={I18n.get('https://www.lapsys.co.jp/english/policy/index.html')}>
            {I18n.get('Privacy policy')}
          </a>
          <a className="mypageFooterLink last" target="_blank" rel="noopener noreferrer" href={I18n.get('mailto:lapsys_e@lapsys.co.jp')}>
            {I18n.get('Contact us')}
          </a>
        </BottomNavigation>
        <p className="mypageFooterRights">&copy; 2018 Laplace System Co., Ltd. All Rights Reserved</p>
      </div>
    );
  };
}

SimpleBottomNavigation.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SimpleBottomNavigation);
